// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"85d250ef","455":"d9b0de31","762":"bc8e30eb","977":"f0da8070"}[chunkId] + ".chunk.js";
};